import { render, staticRenderFns } from "./questionMarkA.vue?vue&type=template&id=35d5ad3a&scoped=true"
import script from "./questionMarkA.vue?vue&type=script&lang=js"
export * from "./questionMarkA.vue?vue&type=script&lang=js"
import style0 from "./questionMarkA.vue?vue&type=style&index=0&id=35d5ad3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d5ad3a",
  null
  
)

export default component.exports